import React, { useEffect, useState, useCallback } from 'react';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import { NumericFormat } from 'react-number-format';
import {
    FaCalculator, FaHistory,
    FaExclamationTriangle, FaTrashAlt, FaWallet, FaCheckCircle
} from 'react-icons/fa';
import './index.css';

const Assistencia = () => {
    const chapa = localStorage.getItem("chapa");

    const [historico, setHistorico] = useState([]);
    const [simulacoes, setSimulacoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [emAberto, setEmAberto] = useState(false);
    const [valorSolicitado, setValorSolicitado] = useState(1000);
    const [solicitacaoPendente, setSolicitacaoPendente] = useState(null);
    const [dadosUsuario, setDadosUsuario] = useState({
        salario: 0,
        valor_permitido: 0,
        loja: 0,
        assistpend: 0
    });

    const formatCurrency = (val) =>
        new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);

    const carregarDados = useCallback(async () => {
        setLoading(true);
        try {
            const userRes = await api.get(`/usuario/dados/${chapa}`);
            let vPendenteDB = 0;

            if (userRes.data && userRes.data[0]) {
                const data = userRes.data[0];
                vPendenteDB = data.assistpend || 0;

                setDadosUsuario({
                    salario: data.salario || 0,
                    loja: data.loja || 0,
                    valor_permitido: data.assistlimite || (data.salario * 0.8),
                    assistpend: vPendenteDB
                });
            }

            const res = await api.get(`/aeflor/assistencia/extrato/${chapa}`);
            setHistorico(res.data);

            const pendenteNoExtrato = res.data.find(item => item.status === 1);

            if (vPendenteDB > 0 || pendenteNoExtrato) {
                setEmAberto(true);
                setSolicitacaoPendente(pendenteNoExtrato || { valor_emp: vPendenteDB });
                setValorSolicitado(vPendenteDB || pendenteNoExtrato?.valor_emp);
            } else {
                setEmAberto(false);
                setSolicitacaoPendente(null);
            }

        } catch (err) {
            console.error("Erro ao carregar dados:", err);
        } finally {
            setLoading(false);
        }
    }, [chapa]);

    useEffect(() => {
        carregarDados();
    }, [carregarDados]);

    const handleSimular = async () => {
        if (!valorSolicitado || valorSolicitado < 100) {
            Swal.fire("Atenção", "Insira um valor mínimo de R$ 100,00", "info");
            return;
        }

        try {
            const res = await api.get(`/aeflor/assistencia/simular/${valorSolicitado}?salario=${dadosUsuario.salario}`);
            setSimulacoes(res.data);

            if (valorSolicitado > dadosUsuario.valor_permitido) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                });
                Toast.fire({
                    icon: 'warning',
                    title: 'Valor acima do permitido. Sujeito a análise especial.'
                });
            }
        } catch (err) {
            Swal.fire("Erro", "Falha ao processar simulação.", "error");
        }
    };

    const handleCancelar = async () => {
        const valorExibir = dadosUsuario.assistpend || solicitacaoPendente?.valor_emp || 0;

        const result = await Swal.fire({
            title: 'Cancelar Solicitação?',
            text: `Deseja remover sua solicitação pendente de ${formatCurrency(valorExibir)}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#8b0000',
            confirmButtonText: 'Sim, cancelar',
            cancelButtonText: 'Sair'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/aeflor/assistencia/cancelar/${chapa}`);
                Swal.fire("Cancelado!", "Solicitação removida com sucesso.", "success");

                setSimulacoes([]);
                setEmAberto(false);
                carregarDados();
            } catch (err) {
                Swal.fire("Erro", "Não foi possível cancelar no momento.", "error");
            }
        }
    };

    const handleSolicitar = async (op) => {
        const { value: motivo } = await Swal.fire({
            title: 'Confirmar Envio',
            html: `
                <div style="text-align:left; background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 15px">
                    <div style="font-size:14px; color: #444">
                        Valor: <b>${formatCurrency(valorSolicitado)}</b><br/>
                        Parcelas: <b>${parseInt(op.parcela)}x de ${formatCurrency(op.valparcela)}</b><br/>
                        Total com Juros: <b>${formatCurrency(op.total)}</b>
                        ${valorSolicitado > dadosUsuario.valor_permitido ? '<br/><span style="color:#c0392b; font-size:11px">⚠️ Valor excede o limite padrão</span>' : ''}
                    </div>
                </div>
                <div style="text-align:left">
                    <label style="font-size: 11px; font-weight: bold; color: #666">MOTIVO DA SOLICITAÇÃO:</label>
                    <textarea id="motivo" class="swal2-textarea" placeholder="Descreva o motivo..." style="height:90px; margin-top: 5px"></textarea>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Confirmar e Enviar',
            confirmButtonColor: '#8b0000',
            preConfirm: () => {
                const texto = document.getElementById('motivo').value;
                if (!texto || texto.trim().length < 5) {
                    Swal.showValidationMessage('O motivo é obrigatório (min. 5 caracteres)');
                    return false;
                }
                return texto;
            }
        });

        if (!motivo) return;

        try {
            await api.post('/aeflor/assistencia/solicitar', {
                matricula: parseInt(chapa),
                valor: valorSolicitado,
                parcelas: parseInt(op.parcela),
                motivo: motivo,
                salario: dadosUsuario.salario,
                loja: dadosUsuario.loja || 0,
                juros: op.juros,
                fator: op.fator,
                valor_total: op.total,
                valor_permitido: dadosUsuario.valor_permitido
            });

            Swal.fire("Solicitado!", "Seu pedido foi enviado para análise do RH.", "success");
            setSimulacoes([]);
            carregarDados();
        } catch (err) {
            Swal.fire("Erro", "Erro ao processar solicitação.", "error");
        }
    };

    return (
        <div className="bg-light w-100 min-vh-100" style={{ paddingTop: '80px' }}>
            <Menu modulo="ARBOR" />

            <div
                className="container py-3 px-2 px-md-4"
                style={{
                    display: 'block',
                    margin: '0 auto !important',
                    maxWidth: '1140px',
                    float: 'none',
                    clear: 'both'
                }}
            >
                <div className="mb-3">
                    <h4 className="fw-bold d-flex align-items-center mb-1 text-danger-gradient">
                        <FaCalculator className="me-2" />
                        Assistência Financeira AEFLOR
                    </h4>
                    <small className="text-muted">Simule e solicite sua assistência financeira com facilidade.</small>
                </div>

                {loading ? (
                    <div className="text-center p-5"><div className="spinner-border text-danger"></div></div>
                ) : (
                    <>
                        <div className="row mb-4 justify-content-center">
                            <div className="col-12 col-md-8 col-lg-6">
                                <div className="card border-0 shadow-sm rounded-4">
                                    <div className="card-body p-3 p-md-4">

                                        <div className="info-financeira mb-3">
                                            <div className="row g-0">
                                                <div className="col-6 p-2 p-md-3 border-end text-center">
                                                    <label className="label-cap d-block mb-1">Seu Salário</label>
                                                    <div className="d-flex align-items-center justify-content-center text-dark fw-bold">
                                                        <FaWallet className="me-2 text-muted" size={14} />
                                                        {formatCurrency(dadosUsuario.salario)}
                                                    </div>
                                                </div>
                                                <div className="col-6 p-2 p-md-3 text-center">
                                                    <label className="label-cap d-block mb-1">Valor Permitido</label>
                                                    <div className="d-flex align-items-center justify-content-center text-danger-gradient fw-bold">
                                                        <FaCheckCircle className="me-2 text-danger" size={14} />
                                                        {formatCurrency(dadosUsuario.valor_permitido)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <label className="label-cap mb-2">Valor da Assistência</label>
                                        <div className="d-flex flex-column flex-md-row gap-2 mb-3">
                                            <div className="flex-grow-1">
                                                <NumericFormat
                                                    className={`form-control form-control-lg fw-bold ${emAberto ? 'bg-light text-muted' : 'border-danger'}`}
                                                    style={{ fontSize: '1.3rem', textAlign: 'center' }}
                                                    value={valorSolicitado}
                                                    onValueChange={(v) => setValorSolicitado(v.floatValue)}
                                                    thousandSeparator="."
                                                    decimalSeparator=","
                                                    prefix="R$ "
                                                    disabled={emAberto}
                                                />
                                            </div>

                                            {emAberto ? (
                                                <button
                                                    className="btn btn-outline-danger fw-bold d-flex align-items-center justify-content-center py-2 px-4"
                                                    onClick={handleCancelar}
                                                >
                                                    <FaTrashAlt className="me-2" /> Cancelar Pedido
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-danger-gradient fw-bold py-2 px-4"
                                                    onClick={handleSimular}
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    Simular
                                                </button>
                                            )}
                                        </div>

                                        {emAberto && (
                                            <div className="alert-pendente p-3 border rounded-3 bg-warning bg-opacity-10 text-dark">
                                                <div className="d-flex align-items-center mb-1">
                                                    <FaExclamationTriangle className="text-warning me-2" />
                                                    <strong className="text-dark">Em análise</strong>
                                                </div>
                                                <div className="small text-secondary">
                                                    Você possui uma solicitação de <strong className="text-dark">{formatCurrency(valorSolicitado)}</strong> em análise pela <strong>AEFLOR</strong>.
                                                </div>
                                            </div>
                                        )}

                                        {!emAberto && (
                                            <div className="mt-3">
                                                {simulacoes.map((s, i) => (
                                                    <div key={i} className={`sim-card ${parseInt(s.parcela) > 6 || valorSolicitado > dadosUsuario.valor_permitido ? 'sim-warning' : ''}`}>
                                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                            <div className="mb-2 mb-sm-0">
                                                                <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                                                    {parseInt(s.parcela)}x de {formatCurrency(s.valparcela)}
                                                                </div>
                                                                <small className="text-muted d-block">Total: {formatCurrency(s.total)}</small>
                                                            </div>
                                                            <button className="btn btn-danger-gradient btn-sm fw-bold px-3" onClick={() => handleSolicitar(s)}>Solicitar</button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* HISTÓRICO DE ASSISTÊNCIAS */}
                        {/* HISTÓRICO DE ASSISTÊNCIAS */}
                        <h5 className="fw-bold mb-3 d-flex align-items-center text-secondary">
                            <FaHistory className="me-2 text-secondary" /> Histórico de Assistências
                        </h5>

                        <div className="row g-3">
                            {historico.length === 0 && (
                                <div className="col-12 text-muted ps-3 small">Nenhum registro encontrado.</div>
                            )}
                            {historico.map((h, i) => {
                                const numParcelas = parseInt(h.parcelas) || 1;
                                const valorTotal = parseFloat(h.valor_total) || 0;
                                const valorParcela = valorTotal / numParcelas;

                                return (
                                    <div key={i} className="col-12 col-md-6">
                                        <div className="card border-0 shadow-sm h-100 rounded-3 card-hover">
                                            <div className="card-body p-3">
                                                {/* Cabeçalho do Card */}
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <span className="badge bg-light text-dark border">ID: {parseInt(h.codemprestimo)}</span>
                                                    <span className={`fw-bold small status-${h.status}`}>
                                                        {h.status === 1 ? '● Pendente' : h.status === 2 ? '● Ativo' : '● Cancelado'}
                                                    </span>
                                                </div>

                                                {/* Datas e Taxa */}
                                                <div className="row g-2 mb-2">
                                                    <div className="col-4">
                                                        <label className="label-cap">Início</label>
                                                        <div className="fw-bold small text-dark">
                                                            {h.dt_emp ? new Date(h.dt_emp).toLocaleDateString('pt-BR') : '--/--/--'}
                                                        </div>
                                                    </div>
                                                    <div className="col-4 text-center">
                                                        <label className="label-cap">Fim</label>
                                                        <div className="fw-bold small text-dark">
                                                            {h.dt_fim ? new Date(h.dt_fim).toLocaleDateString('pt-BR') : '--/--/--'}
                                                        </div>
                                                    </div>
                                                    <div className="col-4 text-end">
                                                        <label className="label-cap">Taxa Contribuição</label>
                                                        <div className="fw-bold small text-danger">
                                                            {h.juros ? `${parseFloat(h.juros).toFixed(2)}%` : '0,00%'}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Valores Principais */}
                                                <div className="row g-2 border-top pt-2 mb-2">
                                                    <div className="col-6">
                                                        <label className="label-cap">Valor Solicitado</label>
                                                        <div className="fw-bold text-secondary" style={{ fontSize: '0.88rem' }}>
                                                            {formatCurrency(h.valor_emp)}
                                                        </div>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                        <label className="label-cap">Total c/ Contribuição</label>
                                                        <div className="fw-bold text-danger" style={{ fontSize: '0.95rem' }}>
                                                            {formatCurrency(h.valor_total)}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 🔹 Destaque do Parcelamento (Quantidade e Valor da Parcela) */}
                                                <div className="p-2 rounded border bg-light text-center mt-2">
                                                    <div className="d-flex justify-content-around align-items-center">
                                                        <div>
                                                            <span className="label-cap d-block">Qtd. Parcelas</span>
                                                            <strong className="text-dark fs-6">{numParcelas}x</strong>
                                                        </div>
                                                        <div className="border-start ps-3">
                                                            <span className="label-cap d-block">Valor da Parcela</span>
                                                            <strong className="text-danger-gradient fs-6">{formatCurrency(valorParcela)}</strong>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>

            <Footer />

            <style>{`
                    .text-danger-gradient { color: #c0392b; font-weight: 800; }
                    .btn-danger-gradient {
                        background: linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%) !important;
                        border: none !important;
                        color: white !important;
                        border-radius: 10px;
                        box-shadow: 0 4px 12px rgba(192, 57, 43, 0.3) !important;
                    }
                    .btn-danger-gradient:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 6px 16px rgba(192, 57, 43, 0.45) !important;
                    }
                    .label-cap { font-size:10px; text-transform:uppercase; color:#888; font-weight:700; letter-spacing:0.5px; }
                    .info-financeira { background: #fcfcfc; border: 1px solid #eee; border-radius: 10px; overflow: hidden; }
                    .card-hover { transition: 0.2s; }
                    .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 16px rgba(0,0,0,0.06) !important; }
                    .sim-card { border: 1px solid #f0f0f0; border-radius: 8px; padding: 12px; margin-bottom: 8px; background: #fff; }
                    .sim-warning { border-left: 4px solid #c0392b !important; background: #fffdf5; }

                    /* 🎨 CORES DOS STATUS CORRIGIDAS */
                    .status-1 { color: #d97706 !important; } /* Laranja: Pendente */
                    .status-2 { color: #198754 !important; } /* Verde: Ativo */
                    .status-3 { color: #6c757d !important; text-decoration: line-through; } /* Cinza: Cancelado */
                `}</style>
        </div>
    );
};

export default Assistencia;